import { render, staticRenderFns } from "./PromoModal.vue?vue&type=template&id=79ab63f9&scoped=true"
import script from "./PromoModal.vue?vue&type=script&lang=js"
export * from "./PromoModal.vue?vue&type=script&lang=js"
import style0 from "./PromoModal.vue?vue&type=style&index=0&id=79ab63f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ab63f9",
  null
  
)

export default component.exports